import { ICONS } from '@frontend/icons';
import React from 'react';

import useSearchTextInput from './search-text-input.controller';

const ID = 'search-text-input';
export interface SearchTextInputProps {
    useConditionedStyling?: boolean;
    required?: boolean;
    valid?: boolean;
    isValidCallback?: (valid: boolean) => void;
    onChange?: (value: string) => void;
    onFocusChange?: () => void;
    value?: string | null;
    errorMessage?: React.ReactNode;
    label?: React.ReactNode;
    helpMessage?: React.ReactNode;
    autoFocus?: boolean;
    disabled?: boolean;
    submitted?: boolean;
    id?: string;
    placeholder?: string;
    icon?: React.ReactElement;

    className?: string;
    resetInput?: () => void;
}

export const SearchTextInput = (props: SearchTextInputProps) => {
    const viewProps = useSearchTextInput(props);

    function getErrorMessage(): React.ReactNode {
        if (props.required) {
            return <>{props.label} is required</>;
        }
        return <>An error occurred with field {props.label}</>;
    }

    return (
        <div
            id={props.id ?? ID}
            className={'inline-flex w-full flex-col items-start justify-start gap-1 self-stretch py-0.5 ' + (props.className ?? '')}>
            {props.label && (
                <label className='inline-flex flex-row items-center justify-start gap-1 self-stretch'>
                    {props.label && props.required ? <span className='text-danger me-1 text-[8px]'>&#9679;</span> : <></>}
                    {props.label}
                    {props.helpMessage && (
                        <>
                            <br />
                            <small className='form-text text-brand-muted'>{props.helpMessage}</small>
                        </>
                    )}
                </label>
            )}
            <div className='outline-border-default bg-background-surface flex w-full items-center rounded-md outline'>
                <div className='text-dark pl-3'>
                    <ICONS.BUTTON.SEARCH className='text-brand-muted h-5 w-5' />
                </div>
                <input
                    className={'form-control placeholder:text-brand-muted bg-background-surface border-0 text-base focus:outline-none'}
                    autoFocus={props.autoFocus}
                    id={props.id}
                    data-testid={props.id}
                    value={viewProps.filterValue ?? ''}
                    type='text'
                    placeholder={props.placeholder}
                    onFocus={() => {
                        viewProps.changeTouched(true);
                        props.onFocusChange && props.onFocusChange();
                    }}
                    required={props.required}
                    onChange={(event) => {
                        if (props.onChange) viewProps.setFilterValue(event.target.value);
                        viewProps.isValid();
                    }}
                    disabled={props.disabled}
                />
                {props.icon && <div className='flex items-center justify-center px-3'>{props.icon}</div>}
            </div>

            {viewProps.valid === false && viewProps.touched === true ? (
                <span className='badge bg-danger mt-2'>
                    <small>{props.errorMessage ?? getErrorMessage()}</small>
                </span>
            ) : (
                <></>
            )}
        </div>
    );
};
